import createCollectionStore from '../create';
import gql from 'nanographql';
import { APP_GRAPHQL } from '../../config';
import UUID from 'uuid';
import { invokeGraphQL } from "../../graphql";

const LIST_APPS = gql`
query listApps {
  apps: listApps {
    uuid
    name
    package
    versions {
        version
        md5
        status
        timestamp
    }
    instances {
        uuid
        identifier
        description
    }
  }
}
`;

const SAVE_APP = gql`
mutation saveApp($data: AppInput!) {
  saved: saveApp(data: $data) {
    uuid
    name
    package
  }
}
`;

const DELETE_APP = gql`
mutation removeApp($uuid: UUID!) {
  removed: removeApp(uuid: $uuid)
}
`;

export default createCollectionStore(
  'App',
  false,
  async () => {
    const result = await invokeGraphQL(
      APP_GRAPHQL,
      LIST_APPS
    );
    return result.apps;
  },
  'uuid',
  [],
  {
    save: async (state, actions, app) => {
      const input = {
        ...app,
        uuid: app.uuid || UUID.v4()
      };
      await invokeGraphQL(
        APP_GRAPHQL,
        SAVE_APP,
        {
          data: {
            uuid: input.uuid,
            name: input.name || '',
            package: input.package || ''
          }
        }
      );
      await actions.updateCache(input);
      return input;
    },
    remove: async (state, actions, uuid) => {
      await invokeGraphQL(
        APP_GRAPHQL,
        DELETE_APP,
        {
          uuid
        }
      );
      await actions.removeCached(uuid);
    }
  }
);



// WEBPACK FOOTER //
// ./src/services/collection/collections/app.js